import type { GQL_ID } from '@@partner:types:graphql'
import type { Labels } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_LABELS_FIELDS } from '@@partner:graphql/shortcuts'
import { LabelFormTranslation } from '@components/marketing/labels/LabelFormState'

export interface MarketingLabelInfoInput {
  upsert?: boolean
  newData: {
    id: GQL_ID
    image_id: GQL_ID
    name: string
    system_name: string
    description: string
    status: number
    sort_order: number
    activeFrom: Date
    activeUntil: Date
    optionColor: string
    optionBackgroundColor: string
    optionLink: string
    optionLinkLabel: string
    i18n: LabelFormTranslation[]
  }
}

export interface SaveLabel {
  labelInfo: Labels
}

export interface SaveLabelVariables {
  labelInfo: MarketingLabelInfoInput
}

export const GQL_MUTATION_SAVE_LABEL = gql`
  mutation($newData: MarketingLabelInfoInput!, $upsert: Boolean!) {
    labelInfo: updateMarketingLabelInfo(newData: $newData, upsert: $upsert) {
      ${SHORTCUT_LABELS_FIELDS}
    }
  }
`

export const useMutateSaveLabel = () =>
  useMutation<SaveLabel, MarketingLabelInfoInput>(GQL_MUTATION_SAVE_LABEL)
